import { render, staticRenderFns } from "./pondFeedTab.vue?vue&type=template&id=7ccbc8de&"
import script from "./pondFeedTab.vue?vue&type=script&lang=js&"
export * from "./pondFeedTab.vue?vue&type=script&lang=js&"
import style0 from "./pondFeedTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports